import {
  fetchEmployeesStart,
  fetchEmployeesSuccess,
  fetchEmployeesFailure,
  updateEmployee,
} from '../slices/employeesSlice';
import { db } from '../../firebase';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';

// Fetch employees by venue ID from Redux
export const fetchEmployees = () => async (dispatch, getState) => {
  try {
    dispatch(fetchEmployeesStart());

    // Retrieve vid from local storage
    const { id: vid } = getState().currentUser.venue;

    // Firestore API call to get employees for the current venue
    const q = query(collection(db, 'employees'), where('vid', '==', vid));
    const querySnapshot = await getDocs(q);
    const employeesData = [];

    querySnapshot.forEach((doc) => {
      const employeeData = doc.data();
      employeesData.push({
        id: doc.id,
        ...employeeData,
      });
    });

    dispatch(fetchEmployeesSuccess(employeesData));
  } catch (error) {
    dispatch(fetchEmployeesFailure(error.message));
  }
};

export const updateEmployeeDetails = (employeeId, formData) => async (dispatch) => {
  try {
    const { name, ...personalDetails } = formData;

    // Update Firestore with both displayName and personalDetails
    const employeeRef = doc(db, 'employees', employeeId);
    await updateDoc(employeeRef, {
      displayName: name,
      personalDetails,
    });

    // Update Redux store
    dispatch(
      updateEmployee({
        id: employeeId,
        updatedEmployee: {
          displayName: name,
          personalDetails,
        },
      })
    );

    return { success: true };
  } catch (error) {
    console.error('Error updating employee details:', error);
    return { success: false, error: error.message };
  }
};
